// Form validation for New Project form
import { plaintextValidator } from '../fields';
import ruleBuilder from '../utils/RuleBuilder';

const config = { mandatory: true };

export default {
  name: plaintextValidator(config),
  selectAttributes: {
    length: {
      minimum: 2,
      tooShort: 'Need atleast two columns'
    }
  },
  ...ruleBuilder('dataCondition.operands', true),
  groupBy: {
    dynamicArray: {
      attribute: {
        presence: { allowEmpty: false }
      },
      unit: {
        presence: { allowEmpty: false }
      }
    }
  }
};
